import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/operation/invite',
  title: '邀请管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
